export default {
  inserted: (el, binding) => {
    if (!window.StatusBar) {
      return;
    }

    if (binding.modifiers.hide) {
      window.StatusBar.hide();
    } else {
      window.StatusBar.backgroundColorByHexString(binding.arg);
      window.StatusBar.show();
    }

    if (binding.modifiers.light) {
      window.StatusBar.styleLightContent();
    } else {
      window.StatusBar.styleDefault();
    }
  }
};
